/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionType from './actionTypes';
import axios from 'axios';
import * as Constants from '../../../../../SharedModules/AppConstants';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { dispatch } from '../../../../System/commentsAndCorrespondence/store/Actions';
import { NO_DRUG_RETRIEVED } from '../../../../../SharedModules/Errors/constantMessageData';

export const searchDrugFamilyList = () => {
  return {
    type: actionType.DRUG_SEARCH_LIST,
    payload: [
      { id: 1, name: Constants.DRUG_NAME, value: 'drugName' },
      { id: 2, name: Constants.GENERIC_CODE, value: 'genericcode' },
      { id: 3, name: Constants.SPECIFIC_THERAPEUTIC_CLASS, value: 'stc' },
      { id: 4, name: Constants.GCN, value: 'gcnSeqNum' },
    ],
  };
};

export const drugFamilyDetail = (values) => {
  return {
    type: actionType.DRUG_FAMILY_DETAILS_DATA,
    payload: values,
  };
};

export const createFlag = (value) => {
  return {
    type: actionType.CREATE_NEW_FLAG,
    payload: value,
  };
};

export const tabValue = (value) => {
  return {
    type: actionType.TAB_VALUE,
    payload: value,
  };
};

export const detailsFormValueStore = (value) => {
  return {
    type: actionType.DETAILS_FORM_VALUES,
    payload: value,
  };
};

export const drugSeqNum = (value) => {
  return {
    type: actionType.DRUG_SEQ_NUM,
    payload: value,
  };
};
export const rightTableData = (value) => {
  return {
    type: actionType.MAINTAIN_RIGHT_TABLE_DATA,
    payload: value,
  };
};

export const copyNDCdata = (value) => {
  return {
    type: actionType.DUP_NDC_DATA,
    payload: value,
  };
};

export const deletedDrugs = (value) => {
  return {
    type: actionType.DELETED_DRUGS,
    payload: value,
  };
};

export const resetDetails = () => {
  return { type: actionType.RESET_STORE };
};

export const detailserrorMsg = (value) => {
  return {
    type: actionType.DETAILS_ERROR_MSGS,
    payload: value,
  };
};

export const deleteDrugFamilyDrugs = (data) => ({
  type: actionType.DELETE_DRUG_FAMILY_DRUGS,
  deleteDrugsList: data,
});

export const updateActionBit = (value) => {
  return {
    type: actionType.UPDATE_ACTION_BIT,
    payload: value,
  };
};

export const dispatchSearchElements = (value) => {
  return {
    type: actionType.DISPATCH_SEARCH_ELEMENTS,
    payload: value,
  };
};

export const viewDrugDetails = (value) => {
  return {
    type: actionType.VIEW_DRUG_DETAILS,
    payload: value,
  };
};

export const updateErrorFieldList = (value) => {
  return {
    type: actionType.ERROR_FIELD_LIST,
    payload: value,
  };
};

export const disableSaveCancel = (value) => {
  return {
    type: actionType.DISABLE_SAVE_CANCEL,
    payload: value,
  };
};

export const clearErrors = () => {
  return {
    type: actionType.RESET_MAINTAIN_PAGE,
  };
};

export const getDrugRouteCodeData = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS}`, values)
    .then((response) => {
      return dispatch({
        type: actionType.DRUG_ROUTE_CODE_DROPDOWN,
        payload: response.data.DRUG_ROUTE_CD,
      });
    })
    .catch((response) => {
      return dispatch({
        type: actionType.DRUG_ROUTE_CODE_DROPDOWN,
        payload: [],
      });
    });
};

export const getMarketBasketData = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MARKET_BASKETS}`, values)
    .then((response) => {
      return dispatch({
        type: actionType.MARKET_BASKET_DATA,
        payload: response.data,
      });
    })
    .catch((response) => {
      return dispatch({
        type: actionType.MARKET_BASKET_DATA,
        payload: [],
      });
    });
};

export const getContractsData = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_CONTRACTS}`, values)
    .then((response) => {
      return dispatch({
        type: actionType.CONTRACTS_DATA,
        payload: response.data.contractDrugFamilyVOs,
      });
    })
    .catch((response) => {
      return dispatch({
        type: actionType.CONTRACTS_DATA,
        payload: [],
      });
    });
};

export const searchDrugFamilyDetail = (values, errList) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SEARCH_DRUG_FAMILY_DETAIL}`, values)
    .then((response) => {
      dispatch({
        type: actionType.MAINTAIN_LEFT_TABLE_DATA,
        payload: response.data.drugResponseVOs,
      });
      if (!response.data.drugResponseVOs.length) {
        dispatch(
          detailserrorMsg([...new Set([...errList, NO_DRUG_RETRIEVED])])
        );
      }
    })
    .catch((response) => {
      dispatch({ type: actionType.MAINTAIN_LEFT_TABLE_DATA, payload: [] });
    });
};

export const saveDrugFamily = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SAVE_DRUG_FAMILY}`, values)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return {};
    });
};

export const getDrugFamilyId = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRUG_FAMILY_ID)
    .then((response) => {
      return dispatch(drugSeqNum(response.data.familySeqNum));
    })
    .catch((response) => {
      return dispatch(drugSeqNum(null));
    });
};

export const getAllManufacturers = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_ACTIVE_MANUFACTURERS)
    .then((response) => {
      dispatch({
        type: actionType.ALL_MANUFACTURER_DATA,
        payload: response.data.mfgVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.ALL_MANUFACTURER_DATA, payload: [] });
    });
};

export const getNewMfgIdData = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_NEW_MFG_ID_DATA}`, values)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return null;
    });
};

export const getNewStc = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_NEW_STC}`, values)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return null;
    });
};

export const getManufacturer = (values) => () => {
  return axios
    .post(`${serviceEndPoint.GET_MANUF_ID_DETAIL}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const getAllManufacturerDetail = (values) => () => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_MANUF_DETAIL}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const getDrugFamilyCompleteDetail = (values) => () => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_SEQUNUM, values)
    .then(async (response) => {
      return response.data;
    })
    .catch((response) => {
      return null;
    });
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
// clear drug family details screen data
export const clearReduxDrugFamilyDetailScreen = () => (dispatch) => {
  dispatch(drugFamilyDetail({}));
  dispatch(detailserrorMsg([]));
  dispatch(updateErrorFieldList({}));
  dispatch({ type: actionType.MAINTAIN_LEFT_TABLE_DATA, payload: [] });
  dispatch({ type: actionType.MAINTAIN_RIGHT_TABLE_DATA, payload: [] });
  dispatch(deletedDrugs([]));
  dispatch(copyNDCdata([]));
};
